import { Auth0ApplicationID, Auth0ApplicationOrgID } from '@gr/shared/models';

export function getProductAuth0AppId() {
  return window.location.origin.includes('grassroots') || window.location.origin.includes('localhost')
    ? Auth0ApplicationID.WONDERCAVE_P2P
    : Auth0ApplicationID.TEXTLEFT_P2P;
}

export function getProductAuth0OrgId() {
  return window.location.origin.includes('grassroots') || window.location.origin.includes('localhost')
    ? Auth0ApplicationOrgID.WONDERCAVE_P2P
    : Auth0ApplicationOrgID.TEXTLEFT_P2P;
}

export function getProductAuth0Domain() {
  return window.location.origin.includes('grassroots') || window.location.origin.includes('localhost')
    ? 'wondercave.us.auth0.com'
    : 'bluewall.us.auth0.com';
}

export function getProductBaseDomainUrl() {
  return window.location.origin.includes('grassroots') || window.location.origin.includes('localhost')
    ? 'grassrootstexts.com'
    : 'textleft.com';
}

export function getProductAudience() {
  return window.location.origin.includes('grassroots') || window.location.origin.includes('localhost')
    ? 'grassroots'
    : 'p2p';
}

export function getProductHtmlPrefix() {
  return window.location.origin.includes('grassroots') || window.location.origin.includes('localhost')
    ? 'grassroots'
    : 'textleft';
}

export function getProductName() {
  return window.location.origin.includes('grassroots') || window.location.origin.includes('localhost')
    ? 'Grassroots'
    : 'Textleft';
}
